export default function getSwipeableSliderLayout(keyCount: number): {
  itemsPerPage: number
} {
  if (keyCount <= 1) {
    return { itemsPerPage: 1 }
  }

  return { itemsPerPage: 2 }
}
